import { animate, motion, useMotionValue } from "framer-motion"
import { useEffect } from "react"
import useMeasure from "react-use-measure"

interface SponsorsProps {
  year: number;
}

const SponsorRow = ({ sponsors, size, duration, reverse }: { sponsors: string[]; size: 'lg' | 'md' | 'sm'; duration: number; reverse?: boolean }) => {
    const [ref, { width }] = useMeasure()
    const xTranslation = useMotionValue(0)
    useEffect(() => {
        const finalPosition = -width / 2 - 8
        const controls = animate(xTranslation, reverse ? [finalPosition, 0] : [0, finalPosition], {
            ease: 'linear',
            duration: duration,
            repeat: Infinity,
            repeatType: "loop",
            repeatDelay: 0
        })
        return controls.stop;
    }, [xTranslation, width, duration, reverse])

    const repeatCount = size === 'sm' ? 8 : size === 'md' ? 6 : 4;
    const repeated = Array(repeatCount).fill(sponsors).flat();

        return (
        <div className={`w-full ${size === 'lg' ? 'h-32 sm:h-36' : size === 'sm' ? 'h-20 sm:h-24' : 'h-28 sm:h-32'} overflow-hidden relative`}>
            <motion.div className="absolute left-0 flex gap-4" ref={ref} style={{ x: xTranslation }}>
                {repeated.map((sponsor, index) => (
                    <div className={`${size === 'lg' ? 'w-72 sm:w-80 h-32 sm:h-36 p-1.5' : size === 'sm' ? 'w-48 sm:w-56 h-20 sm:h-24 p-3' : 'w-64 sm:w-72 h-28 sm:h-32 p-4'} rounded-md border border-darkBlue overflow-hidden backdrop-blur-sm flex items-center justify-center`} key={index}>
                        <img className="w-full h-full object-contain" alt={`sponsor-${index}`} src={sponsor}/>
                    </div>
                ))}
            </motion.div>
        </div>
    )
}

const Sponsors: React.FC<SponsorsProps> = ({ year }) => {
    const sponsorList: Record<number, string[]> = {
        2024: ["/images/rexroth.png", "/images/rexroth.png", "/images/rexroth.png"],
        2026: ["/images/Sponsor-placeholder.png", "/images/Sponsor-placeholder.png", "/images/Sponsor-placeholder.png"],
    } 
    const sponsors = sponsorList[year] || [];

    return (
        <section id="sponsor" className="w-full flex flex-col gap-3.5 py-2 overflow-hidden relative">
            <SponsorRow sponsors={sponsors} size="lg" duration={32} />
            <SponsorRow sponsors={sponsors} size="md" duration={28} reverse={true}/>
            <SponsorRow sponsors={sponsors} size="sm" duration={24} />
        </section>
    )
}
export default Sponsors
